import { render, staticRenderFns } from "./MiniFormObject.vue?vue&type=template&id=808d02aa&scoped=true&"
import script from "./MiniFormObject.vue?vue&type=script&lang=js&"
export * from "./MiniFormObject.vue?vue&type=script&lang=js&"
import style0 from "./MiniFormObject.vue?vue&type=style&index=0&id=808d02aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808d02aa",
  null
  
)

export default component.exports